module.exports = __webpack_public_path__ + "img/blog_1.fe64addc.jpg";